import React from "react";
import Carousel from "components/common/Carousel";
import Skeleton from "components/common/Skeleton";
import styles from "./index.module.scss";

const BlockSkeleton = ({
  carouselItemRender,
  item,
}) => {
  return (
    <>
      <h1 className={styles["block__title"]}>
        <Skeleton />
      </h1>
      <Carousel
        items={item}
        renderItem={carouselItemRender}
      />
    </>
  );
};

export default BlockSkeleton;
